import React, { useEffect, useState, useRef } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Alert, Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatAddress, formatDateTime, getPurchaseStatus } from 'helpers/format'
import { PurchaseDetailReq, UpdatePurchaseStatusReq } from 'Store/purchase/types'
import { getPurchaseDetailAPI, updatePurchaseStatusAPI } from 'Store/purchase/api'
import {
  selectPurchaseActionEvent,
  selectPurchaseDetail,
  selectPurchaseDetailEvent,
} from 'Store/purchase/selector'
import { selectCurrentUser } from 'Store/user/selector'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/purchase/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import ProductsTable from './components/ProductsTable'
import { selectAllSupplierList } from 'Store/supplier/selector'
import { InfoItem } from 'Pages/Merchants/components'
import { StatusTag } from 'Components/utilities'
import { ConfirmQuestion } from 'Components/modal'
import PurchasePDF from './components/PurchasePDF'
import { PurchaseStatus } from 'helpers/constanst'
import { getUserLogin } from 'helpers/account'
import DetailHeader from './components/DetailHeader'
import PickupDetail from '../Pickup/detail'
import RecievePDF from './components/RecievePDF'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  id?: number
}

const PurchaseDetail: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    detail,
    detailEvent,
  } = props

  const dispatch = useDispatch()
  const [rejectDialog, setRejectDialog] = useState(false)
  const [closePurchaseDialog, setClosePurchaseDialog] = useState(false)
  const [showPickupDrawer, setshowPickupDrawer] = useState(false)
  const userInfo = getUserLogin()
  const purchasePDF = useRef(null as any)
  const purchaseLitePDF = useRef(null as any)
  const recieveePDF = useRef(null as any)
  const recieveLitePDF = useRef(null as any)
  const isFranchise = currentUser?.activeMerchant?.is_fc === true

  useEffect(() => {
    if (visible) {
      onGetDetail()
    }
  }, [visible])

  const onGetDetail = (): void => {
    const req: PurchaseDetailReq = {
      id,
    }
    dispatch(getPurchaseDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onConfirmCancel = (status: PurchaseStatus, reason: string): void => {
    const req: UpdatePurchaseStatusReq = {
      id,
      status,
      reason,
      username: userInfo?.username || '',
    }
    dispatch(updatePurchaseStatusAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onClickCancel = (): void => {
    setRejectDialog(true)
  }

  const onClickClose = (): void => {
    setClosePurchaseDialog(true)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    setRejectDialog(false)
    setClosePurchaseDialog(false)
    clearEvent()
    onSuccess()
  }

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return <InfoItem title={title} value={value} span={span} />
  }

  const renderPurchaseInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>รายละเอียดการสั่งซื้อ</BoxTitle>
        <Row gutter={8}>
          <Col md={12} xs={24}>
            {renderInfo('วันที่สั่งซื้อ', formatDateTime(detail?.purchasing_date || ''))}
            {renderInfo('ผู้ออกใบสั่งซื้อ', detail?.purchasing_by)}
          </Col>
          <Col md={12} xs={24}>
            {renderInfo('หมายเหตุ', detail?.remark)}
            {renderInfo('สถานะใบสั่งซื้อ', renderStatus(detail?.status || ''))}
            {detail?.reason && renderInfo('เหตุผล', <Reason>{detail?.reason || '-'}</Reason>)}
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const renderSupplierInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>ข้อมูลบริษัท/Supplier</BoxTitle>
        {renderInfo('ชื่อ', detail?.supplier?.name)}
        {renderInfo('ที่อยู่', detail?.supplier?.address)}
        {renderInfo('เบอร์โทรศัพท์', detail?.supplier?.mobile_no)}
      </BoxWrapper>
    )
  }

  const renderClientInfo = () => {
    return (
      <BoxWrapper>
        <BoxTitle>ข้อมูลลูกค้า</BoxTitle>
        {renderInfo('ชื่อ', detail?.merchant?.name)}
        {renderInfo(
          'ที่อยู่',
          formatAddress(
            detail?.merchant?.address,
            detail?.merchant?.district,
            detail?.merchant?.amphor,
            detail?.merchant?.province,
            detail?.merchant?.postcode,
          ),
        )}
        {renderInfo('เบอร์โทรศัพท์', detail?.merchant?.phone)}
      </BoxWrapper>
    )
  }

  const renderFooterContent = () => {
    const status = detail?.status

    if (status == PurchaseStatus.PENDING && !isFranchise) {
      return (
        <Space size="middle" align="baseline">
          <PrimaryButton text="ยกเลิกใบสั่งซื้อ" btnType="Reject" onClick={onClickCancel} />
          <PrimaryButton
            btnType="Approve"
            text="รับสินค้าเข้าคลัง"
            onClick={() => {
              onCloseDrawer()
              setshowPickupDrawer(true)
            }}
          />
        </Space>
      )
    }

    if (status == PurchaseStatus.PARTIAL_RECEIPT && !isFranchise) {
      return (
        <Space size="middle" align="baseline">
          <PrimaryButton text="ปิดใบสั่งซื้อ" btnType="Cancel" onClick={onClickClose} />
          <PrimaryButton
            btnType="Approve"
            text="รับสินค้าเข้าคลัง"
            onClick={() => {
              onCloseDrawer()
              setshowPickupDrawer(true)
            }}
          />
        </Space>
      )
    }
    return null
  }

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title={`ยกเลิกใบสั่งซื้อ`}
      label="ระบุเหตุผล"
      placeholder="เช่น ออกรายการสั่งซื้อผิดพลาด..."
      confirmBtnTxt="ยืนยัน"
      isShow={rejectDialog}
      handleOk={(remark: string) => onConfirmCancel(PurchaseStatus.CANCEL, remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmClosePurchaseDailog = (
    <ConfirmQuestion
      title={`ปิดใบสั่งซื้อ`}
      label="ระบุเหตุผล"
      placeholder="เช่น ออกรายการสั่งซื้อผิดพลาด..."
      confirmBtnTxt="ยืนยัน"
      isShow={closePurchaseDialog}
      handleOk={(remark: string) => onConfirmCancel(PurchaseStatus.CONDITION_RECEIPT, remark)}
      handleCancel={() => setClosePurchaseDialog(false)}
      loading={event.IsLoading}
    />
  )

  const PickupDrawer = (
    <PickupDetail
      id={id}
      visible={showPickupDrawer}
      onCloseDrawer={() => setshowPickupDrawer(false)}
      onSuccess={() => {
        setshowPickupDrawer(false)
        onSuccess()
      }}
    />
  )

  const renderStatus = (status: string) => {
    const statusResult = getPurchaseStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const renderTitle = () => {
    return <DetailHeader id={id} purchasing_no={detail?.purchasing_no} detail={detail} />
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={renderFooterContent()}
      width={'90%'}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      {ConfirmRejectDailog}
      {ConfirmClosePurchaseDailog}
      {PickupDrawer}
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={16}>
        <Col md={24} xs={24}>
          <ProductsTable
            products={detail?.purchasing_item || []}
            viewMode={true}
            purchasePdfRef={purchasePDF}
            purchaseLitePdfRef={purchaseLitePDF}
            recievePdfRef={recieveePDF}
            purchasing_no={detail?.purchasing_no}
            recieveLitePDF={recieveLitePDF}
            detail={detail}
          />
        </Col>
        <Col md={24} xs={24}>
          {renderPurchaseInfo()}
        </Col>
        <Col md={12} xs={24}>
          {renderSupplierInfo()}
        </Col>
        <Col md={12} xs={24}>
          {renderClientInfo()}
        </Col>
        {isFranchise && detail?.status == PurchaseStatus.PENDING && (
          <Col md={24} xs={24}>
            <MyAlert
              type="warning"
              message={`หมายเหตุ : กรณีต้องการยกเลิกใบสั่งซื้อสินค้า กรุณาแจ้งไปสาขาใหญ่แฟรนไชส์เพื่อดำเนินการยกเลิก เมื่อสาขาใหญ่แฟรนไชส์ดำเนินการยกเลิกใบสั่งซื้อแล้วรายการจะถูกย้ายไปยังแถบสถานะ “ยกเลิก” ให้อัตโนมัติ`}
            />
          </Col>
        )}
        {isFranchise && detail?.status == PurchaseStatus.PARTIAL_RECEIPT && (
          <Col md={24} xs={24}>
            <MyAlert
              type="warning"
              message={`หมายเหตุ : กรณีต้องการยกเลิกใบสั่งซื้อสินค้า กรุณาแจ้งไปสาขาใหญ่แฟรนไชส์เพื่อดำเนินการยกเลิก เมื่อสาขาใหญ่แฟรนไชส์ดำเนินการยกเลิกใบสั่งซื้อแล้วรายการจะถูกย้ายไปยังแถบสถานะ “ยกเลิก” ให้อัตโนมัติ`}
            />
          </Col>
        )}
      </Row>
      <Row ref={purchasePDF}>
        <Col span={24}>
          <PurchasePDF detail={detail} />
        </Col>
      </Row>
      <Row ref={purchaseLitePDF}>
        <Col span={24}>
          <PurchasePDF detail={detail} isLite />
        </Col>
      </Row>
      <Row ref={recieveePDF}>
        <Col span={24}>
          <RecievePDF detail={detail} />
        </Col>
      </Row>
      <Row ref={recieveLitePDF}>
        <Col span={24}>
          <RecievePDF detail={detail} isLite />
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const MyAlert = styled(Alert)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2} !important;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const Reason = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectPurchaseActionEvent(state),
    detail: selectPurchaseDetail(state),
    detailEvent: selectPurchaseDetailEvent(state),
    supplierList: selectAllSupplierList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PurchaseDetail)
